import style from './style/NoAvailableProduct.module.css'

const NoAvailableProducts = () => {
    return (
        <div className={style['paragraph']}>
           <h4 className={style['text']}> No available products </h4>
        </div>
    )
}
export default NoAvailableProducts